"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagLabelMaxLength = void 0;
exports.tagLabelMaxLength = 30;
